// disable until I figure out a better way to isolate builds. Need a feature
// flag considers the build and deletes older/unused caches.
export const ALLOW_LOCAL_STORAGE = false;
